import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExternalEoiGenerateModalModule } from '@common/external-eoi-generate-modal/external-eoi-generate-modal.module';
import { ExternalEoiLinksModule } from '@common/external-eoi-links/external-eoi-links.module';
import { GenaricNotesModule } from '@common/notes/notes.module';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { LibraryMenuModule } from '@modules/library/private/library-menu/library-menu.module';
import { LibraryViewModeModule } from '@modules/library/private/library-view-mode/library-view-mode.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { EditUnitModule } from '../../unit/edit-unit/edit-unit.module';
import { EditEoiComponent } from './edit-eoi.component';
import { TableModule } from 'primeng/table';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';
import { PriceInputModule } from '@common/price-input/price-input.module';
import { MentionDirective } from './mention.directive';

@NgModule({
  declarations: [EditEoiComponent, MentionDirective],
  imports: [
    CommonModule,
    NgSelectModule,
    RadioButtonModule,
    CalendarModule,
    CheckboxModule,
    LibraryViewModeModule,
    LibraryMenuModule,
    DialogModule,
    TableModule,
    EditUnitModule,
    GenaricNotesModule,
    FormsModule,
    ReactiveFormsModule,
    ReMultiselectModule,
    ReMultipleSelectModule,
    PriceInputModule,
    ExternalEoiGenerateModalModule,
    ExternalEoiLinksModule,
  ],
  exports: [EditEoiComponent],
})
export class EditEoiModule {}
